import logo from "../res/logo.png";

function Footer() {
  return (
    <div className="bg-gray-100 dark:bg-gray-900">
      <div className="container mx-auto px-5 pt-[40px] pb-[48px] lg:px-[60px] lg:pt-[70px]">
        <a className="inline-flex" href="../">
          <img className="w-20 py-0 my-0" src={logo} alt="" />
        </a>
        <div className="mt-8 grid grid-cols-1 gap-12 lg:grid-cols-4">
          <div className="text-gray-900 dark:text-gray-100">
            <p className="font-bold">
              PHILIPPINE ENGINEERING AND AGRO-INDUSTRIAL COLLEGE, INC.
            </p>

            <p className="mt-4">
              The Philippine Engineering and Agro-Industrial College, Inc.
              (PEACI) is a private, non-stock, non-profit educational
              institution, founded in 2007 by a group of Meranao engineers.
            </p>
          </div>
          <div className="line-height-[24px] text-gray-900 dark:text-gray-100">
            <p className="font-medium">Contact Us:</p>
            <div className="mt-4">
              Address: <br />
              Datu Gonsi St.,
              <br />
              Lomidong, Marawi City,
              <br />
              Philippines
            </div>
            <p className="mt-3 block">
              Mobile:
              <span className="ml-1 text-gray-900 dark:text-gray-100 font-bold">
                +63 912-686-2990
              </span>
            </p>

            <a
              href="mailto:peaci.school@gmail.com"
              target="_blank"
              rel="noreferrer"
              className="mt-3 block"
            >
              Email:
              <span className="ml-1 text-gray-900 dark:text-gray-100 font-bold">
                ict@peaci.edu.ph
              </span>
            </a>
          </div>
          <div className="col-span-1">
            <h3 className="font-medium text-gray-900 dark:text-gray-100">Developed By:</h3>
            <div className="mt-4">
              <h2 className="text-gray-900 dark:text-gray-100 font-bold">Mellhabib M. Angni</h2>
            </div>
            <div className="mt-2">
              <a
                className="text-amber-600 dark:text-amber-400 underline underline-offset-4 hover:text-amber-700 dark:hover:text-amber-300"
                href="../webadmin"
              >
                Web Admin Login
              </a>
            </div>
          </div>
        </div>
        <div className="mt-[30px] grid grid-cols-2 flex-wrap gap-[20px] lg:mt-[60px] lg:flex lg:space-x-10">
          <a className="text-gray-900 dark:text-gray-100 hover:text-amber-600 dark:hover:text-amber-400" href="../programs">
            Programs
          </a>
          <a className="text-gray-900 dark:text-gray-100 hover:text-amber-600 dark:hover:text-amber-400" href="../about">
            About PEACI
          </a>
          <a className="text-gray-900 dark:text-gray-100 hover:text-amber-600 dark:hover:text-amber-400" href="https://my.peaci.edu.ph/">
            My.PEACI
          </a>
        </div>
        <div className="mt-12 flex flex-col-reverse items-start justify-between border-t border-gray-300 dark:border-gray-600 pt-8 lg:flex-row lg:items-center">
          <p className="mt-[30px] text-gray-600 dark:text-gray-400 lg:mt-0">
            Copyright (c) 2026 Philippine Engineering and Agro-Industrial
            College, Inc. All Right Reserved.
          </p>
          <div className="flex items-center space-x-6">
            <a
              className="flex-shrink-0"
              href="https://www.facebook.com/PEACIofficial"
            >
              <svg
                className="h-6 w-6 fill-current text-gray-600 dark:text-gray-400 hover:text-amber-600 dark:hover:text-amber-400"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              >
                <path d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
